export default "__VITE_ASSET__Dg$rOj$L__"